import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useSelector } from 'react-redux'
import {
    Alert,
    AlertTitle,
    Box,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import {
    formatDateToDDMMYYYY,
    formatNumber,
} from '../../../../../utils/helpers'
import { ReceiptStatus } from '../ReceiptsTable/ReceiptStatus'

export const AddReceiptFailedReport = () => {
    const {
        failedReceipts,
        failedReceiptsPayload,
        allCompanies,
        allCurrencies,
    } = useSelector((state: any) => state.receipts)

    const UploadedReceiptsWithDetails = failedReceipts
        .filter((receipt: any) => receipt.created === true)
        .map((failedReceipt: any) => {
            const payloadData = failedReceiptsPayload?.receipts?.find(
                (payload: any) =>
                    payload.receipt_id === failedReceipt.receipt_id
            )
            return {
                ...payloadData,
                ...failedReceipt,
            }
        })

    const failedCount = failedReceipts.filter(
        (item: any) => item.created === false || item.created === 'false'
    ).length

    return (
        <>
            <Alert
                severity="error"
                icon={<ErrorOutlineIcon />}
                sx={{
                    backgroundColor: '#fef2f2',
                    borderColor: '#fecaca',
                    color: '#7f1d1d',
                    '& .MuiAlert-icon': {
                        color: '#dc2626',
                    },
                }}
            >
                <AlertTitle sx={{ mb: 0.5, fontWeight: 500 }}>
                    Some records weren't uploaded successfully.
                </AlertTitle>
                <Box sx={{ fontSize: '0.875rem' }}>
                    {failedCount} of {failedReceipts.length} records failed.{' '}
                </Box>
            </Alert>
            {UploadedReceiptsWithDetails &&
            UploadedReceiptsWithDetails.length > 0 ? (
                <>
                    <Typography variant="h6" sx={{ mb: 4, mt: 4 }}>
                        Records Uploaded
                    </Typography>
                    <Box>
                        <TableContainer
                            className="receiptsTable"
                            sx={{ my: 3 }}
                        >
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Company</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Receipt Number</TableCell>
                                        <TableCell>Receipt Amount</TableCell>
                                        <TableCell>Receipt Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {UploadedReceiptsWithDetails?.map(
                                        (receipt: any) => (
                                            <TableRow key={receipt?.receipt_id}>
                                                <TableCell>
                                                    {
                                                        allCompanies?.find(
                                                            (company: any) =>
                                                                company?.shared_uid ===
                                                                receipt?.company_shared_uid
                                                        )?.finance_company_name
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {formatDateToDDMMYYYY(
                                                        receipt?.receipt_date
                                                    ) || ''}
                                                </TableCell>
                                                <TableCell>
                                                    {receipt?.receipt_id}
                                                </TableCell>
                                                <TableCell>
                                                    <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                    >
                                                        {formatNumber(
                                                            receipt?.receipt_amount
                                                        )}
                                                        <Stack
                                                            sx={{
                                                                color: 'rgba(0, 0, 0, 0.56)',
                                                                fontSize:
                                                                    '18px !important',
                                                                fontWeight:
                                                                    '400',
                                                                ml: 0.5,
                                                            }}
                                                        >
                                                            {
                                                                allCurrencies?.find(
                                                                    (
                                                                        currency: any
                                                                    ) =>
                                                                        currency?.shared_uid ===
                                                                        receipt?.receipt_currency_shared_uid
                                                                )
                                                                    ?.currency_symbol
                                                            }
                                                        </Stack>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <ReceiptStatus
                                                        status={
                                                            receipt?.receipt_status
                                                        }
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </>
            ) : null}
        </>
    )
}
